export default __webpack_public_path__ + "static/media/AccountSettingMobile.6e84f559.svg";